<template>
    <div class="PageRegister">
      <arrowLeft style="margin-left: -8px"></arrowLeft>
      <div class="login">
        <div class="login-left">新用户注册</div>
        <div class="login-right" @click="$router.push('/login')">去登录></div>
      </div>

      <div style="margin-top: 24px">
        <van-form @submit="onsubmit">
          <van-field v-model="account"
                     name="account"
                     type="tel" placeholder="请输入手机号"
                     style="background: #F5F5F5;font-size: 15px"
                     :rules="[{ required: true }]"
                     maxlength="11"/>
            <van-field v-model="code"
                       type="digit"
                       name="code"
                       maxlength="6"
                       placeholder="请输入验证码"
                       :rules="[{ required: true }]"
                       style="background: #F5F5F5;margin-top: 8px;font-size: 15px">
              <template #button>
                <div class="yzm" @click="getCode" v-if="timerTf">获取验证码</div>
                <div class="yzm" v-else>{{countDownNum}}s后获取</div>
              </template>
            </van-field>
          <van-field v-model="password"
                     type="password"
                     name="password"
                     placeholder="8-16位(必须包含大小写字母、数字、特殊字符)"
                     :rules="[{ required: true }]"
                     style="background: #F5F5F5;margin-top: 8px;font-size: 15px"/>
          <div style="margin-top: 24px;">
            <van-button
              round block type="info"
              native-type="submit"
              style="background: #224A91;border-radius: 4px;"
            >立即注册</van-button>
          </div>
        </van-form>
      </div>

      <div class="tips">提示:若无法注册,请先联系医生创建账号</div>
      <logo></logo>
    </div>
</template>

<script>
import arrowLeft from '@/components/arrow-left'
import logo from "@/components/logo";
import {userRegister,sendMobile} from '../service/api'
import { base64_encode, authcode} from "@/utils/md5";

export default {
  // eslint-disable-next-line vue/multi-word-component-names
  name: "register",
  methods:{
    // 获取验证码
    getCode(){
      if (this.account.length < 11) {
        this.$toast('请输入正确的手机号')
      }else {
        sendMobile({mobile:this.account}).then( res=> {
          console.log(res)
          this.countDownNum = 60
          this.timerTf = false
          this.timer = setInterval(() => {
            this.countDownNum--
            if (this.countDownNum <= 0) {
              this.timerTf = true
              clearInterval(this.timer)
            }
          }, 1000)
          this.$toast('发送成功')
          }
        ).catch( err => {
          this.$toast('发送失败,'+err.message)
        })
      }
    },
    onsubmit(val){
      console.log('?????',val);
      let params=val
      params.password=base64_encode(authcode(params.password,'ENCODE',"ertongyiyuan20240305"));
      userRegister(params).then( res =>{
          localStorage.setItem('wa-token',res.data.token)
          this.$router.push({'path':'/health',query:{'show':1}})
          this.$toast(res.msg)
        }).catch( err => {
          this.$toast(err.message)
        })
    },
  },
  data(){
    return {
      account:'',
      password:'',
      code:'',
      timerTf:true,
      countDownNum:60,
      timer:null
    }
  },
  components:{
    logo,
    arrowLeft
  }
}
</script>

<style scoped lang="scss">
.PageRegister{
  padding: 24px;
  background: #fefffe;
  .yzm{
    background: #F5F5F5;
    border-style:none;
    border-left:1px solid #979797;
    font-size: 13px;
    width: 89px;
    text-align: center;
  }
  .login{
    margin-top: 36px;
    display: flex;
    justify-content : space - between;
    .login-left{
      height: 32px;
      font-weight: 600;
      font-size: 24px;
    }
    .login-right{
      font-weight: 400;
      padding-top: 5px;
      text-decoration: underline;
      align-self: flex-end;
      font-size: 15px;
      color: #224A91;
    }
  }
  .tips{
    margin-top: 16px;
    font-size: 12px;
    font-weight: 400;
    text-align: center;
    color: #888a7b;
    line-height: 18px;
  }
}
</style>